import { useNavigate, useParams } from "react-router-dom";

import { Tabs, Tab } from "components/layout";
import { pathToUrl } from "utils/url";

import { MAIN_ROUTE } from "../constants";
import { DetailsTabArray } from "./types";

type CreateTabLinkProps = {
  id: string;
  tabId: string;
  variantId: string | undefined;
};

export type TiVoAppDetailsTabsProps = {
  tabs: DetailsTabArray;
};

const createTabLink = ({ id, tabId, variantId }: CreateTabLinkProps) => {
  let path = `/${MAIN_ROUTE}/details/:id`;
  if (variantId) {
    path += "/variant/:variantId";
  }
  path += "/:tabId";
  const params: Record<string, string> = { tabId };
  if (id) {
    params["id"] = encodeURIComponent(id);
  }
  if (variantId) {
    params["variantId"] = encodeURIComponent(variantId);
  }
  return pathToUrl(path, params);
};

const getActiveTab = (
  tabs: DetailsTabArray,
  params: Record<string, string | undefined>
) => tabs.findIndex(({ path }) => path === params["*"]);

export function TiVoAppDetailsTabs({ tabs }: TiVoAppDetailsTabsProps) {
  const navigate = useNavigate();
  const params = useParams();

  const renderTabs = () =>
    tabs.map((tab, idx) => {
      return (
        <Tab
          key={tab.path}
          active={getActiveTab(tabs, params) === idx}
          text={tab.text}
          dataTestId={tab.dataTestId}
          onClick={() => {
            navigate(
              createTabLink({
                id: params.id || "",
                tabId: tab.path,
                variantId: params.variantId,
              })
            );
          }}
        />
      );
    });

  return <Tabs>{renderTabs()}</Tabs>;
}
